import React from 'react';
import { Text } from '@mantine/core';
import Link from '../Link';
import TermsPrivacyPageTemplate from './TermsPrivacyPageTemplate';

function PrivacyPage() {

  const content = {
    title: 'Privacy policy',
    breadcrumb: 'Privacy',
    href: '/privacy',
    lastUpdated: 'March 10, 2025',
    subheading: <Text>At <Link href='/'>twiz.app</Link>, we are committed to protecting your privacy.</Text>,
    sections: [
        {
            title: 'Information we collect',
            subheading: 'We collect personal data when you:',
            bullets: [
                'Create an account or make a purchase.',
                'Contact us via email or support channels.',
                'Browse our website (cookies & analytics data).'
            ]
        },
        {
          title: 'How we use your information',
          subheading: 'We use your information to:',
          bullets: [
              'Process payments and fulfill orders.',
              'Provide customer support.',
              'Improve our services and website.'
          ]
        },
        {
          title: 'How we share your information',
          subheading: null,
          bullets: [
              <Text><Text span fw={600}>Payment processing:</Text> We share payment details with <Link newTab href='https://www.stripe.com'>Stripe</Link> to process transactions.</Text>,
              <Text><Text span fw={600}>Legal compliance:</Text> We may disclose information if required by law.</Text>,
          ]
        },
        {
          title: 'Security of your information',
          subheading: 'We use industry-standard security measures, but no method of transmission is 100% secure.',
          bullets: []
        },
        {
          title: 'Your rights',
          subheading: <Text>You may request to access, update, or delete your personal data by <Link href='?contact=true'>contacting us</Link>.</Text>,
          bullets: []
        },
        {
          title: 'Cookies & tracking',
          subheading: 'We use cookies to improve user experience and track website performance. You can disable cookies in your browser settings.',
          bullets: []
        },
        {
          title: 'Contact information',
          subheading: <Text>For privacy-related inquiries, <Link href='?contact=true'>contact us</Link>.</Text>,
          bullets: []
        }
    ]
  };

  return (
    <TermsPrivacyPageTemplate content={content} />
  )

}

export default PrivacyPage;